import { createTheme } from '@mui/material';

const theme = createTheme({
  palette: { primary: { main: '#779351' } },
});

export default theme;
